import { useTranslator } from '@bluebeam/react-i18n';
import BackButton from 'components/BackButton';
import React, { useEffect, useState } from 'react';
import { useIntegrationsCheck } from 'hooks/useIntegrationsCheck';
import { RadioGroup } from '@bluebeam/react-skyline-radio';

type DestinationToExport = {
  studio: boolean;
  integrations: boolean;
};

interface Props {
  onChange(destinationToExport: DestinationToExport): void;
  onBackClick(): void;
}

const SelectDestinationToExport: React.FC<Props> = ({
  onChange,
  onBackClick,
}) => {
  const { translate } = useTranslator(['exportProjectData', 'buttons']);
  const [destinationToExport, setDestinationToExport] = useState({
    studio: false,
    integrations: false,
  });

  const handleStudioProjectToExport = (): void => {
    setDestinationToExport({
      integrations: false,
      studio: true,
    });
  };
  const handleIntegrationsToExport = (): void => {
    setDestinationToExport({
      integrations: true,
      studio: false,
    });
  };

  const radioInputChangeHandler = (value: string) => {
    if (value === 'Studio Projects') {
      handleStudioProjectToExport();
    } else if (value === 'Integrations') {
      handleIntegrationsToExport();
    }
  };
  useEffect(() => {
    onChange(destinationToExport);
  }, [destinationToExport]);

  const { areIntegrationsEnabled } = useIntegrationsCheck();

  return (
    <div>
      <BackButton onBackClick={onBackClick} />
      <div css={{ fontFamily: 'Roboto' }}>
        <div
          className=" medium font-size-5 leading-5 "
          css={{ paddingBottom: '12px' }}
        >
          {translate('exportProjectData:selectLocationTitle')}
        </div>
        <div className="pb3 normal font-size-5 leading-[22px] ">
          {translate('exportProjectData:selectLocationText')}
        </div>
      </div>
      <hr css={{ border: '0.5px solid #DCDFE3' }} />
      <div className="pb2" css={{ fontFamily: 'Roboto' }}>
        <div
          className="row mb-1 mt-4 text-[14px] leading-[16px]"
          css={{ color: '#6E6F70' }}
        >
          {translate('exportProjectData:selectLocationLabel')}
        </div>

        <RadioGroup
          onChange={(value) => radioInputChangeHandler(value)}
          ariaLabel="radio-destination"
        >
          {areIntegrationsEnabled && (
            <div className="py-2.5">
              <RadioGroup.Option value="Integrations">
                <label htmlFor="radio-integrations" className="text-base">
                  {translate('exportProjectData:integrations')}
                </label>
              </RadioGroup.Option>
            </div>
          )}

          <div className="py-2.5">
            <RadioGroup.Option value="Studio Projects">
              <label htmlFor="radio-studioProjects" className="text-base">
                {translate('exportProjectData:stuidoProjects')}
              </label>
            </RadioGroup.Option>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default SelectDestinationToExport;
